export interface VisitorStats {
  unique_users: number;
}
export interface ViewStats {
  total_views: number;
}
export interface EventStats {
  total_events: number;
}

export enum QueryType {
  METRICS = 'metrics',
  STATS = 'stats',
}

export enum ChartType {
  EVENT_STATS = 'event_stats',
  VISITOR_STATS = 'visitor_stats',
  PAGE_VIEW_STATS = 'page_view_stats',
  UNIQUE_VISITORS = 'unique_visitors',
  TOP_CUSTOMERS = 'top_customers',
  ASSOCIATED_CAMPAIGNS = 'associated_campaigns',
  CE_ITEM_STATS = 'ce_item_stats',
  OVER_ALL_SHIPPING_PERFORMANCE = 'overall_shipping_performance',
  STATE_WISE_SHIPMENTS_DELIVERY = 'state_wise_shipments_delivery',
  STATE_WISE_SHIPPING_PERFORMANCE = 'city_wise_shipping_performance',
  AVERAGE_SHIPPING_TIME_PER_COURIER = 'average_shipping_time_per_courier', // need to remove this
  AVERAGE_TIME_BETWEEN_SUBSEQUENT_PURCHASES = 'average_time_between_subsequent_purchases',
  PRODUCT_CHECKOUT_FUNNEL = 'product_checkout_funnel',
  CHECKOUT_FUNNEL = 'checkout_funnel',
}
